import { RelationshipType } from './RelationshipType';

export class SearchRelationshipRequest {
    tags: string = '';

    private t: string = 'Unknown';

    get type(): RelationshipType {
        let type = (RelationshipType as any)[this.t] as RelationshipType;
        return type;
    }

    set type(type: RelationshipType) {
        this.t = RelationshipType[type];
    }

    lastId?: string;
    limit: number = 15;
    desc: boolean = false;
}